import React from "react";
import { Box, Button, Chip, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import Search from "../../../../common/Search/Search";

const formatMembershipLabel = (membership) => {
  const startDate = new Date(membership.start);
  const endDate = new Date(membership.end);
  const now = new Date();
  const productName = membership.products[0].name;
  
  const start = startDate.toLocaleDateString("es-AR", { 
    day: "2-digit", 
    month: "short", 
    year: "numeric" 
  });
  const end = endDate.toLocaleDateString("es-AR", { 
    day: "2-digit", 
    month: "short", 
    year: "numeric" 
  });
  
  // Determinar si está activa
  const isActive = now >= startDate && now <= endDate;
  const isPast = now > endDate;
  const isFuture = now < startDate;
  
  let status = "";
  if (isActive) status = "✓ ";
  if (isPast) status = "✕ ";
  if (isFuture) status = "⏳ ";
  
  return `${status}${productName} - ${end}`;
};

const TopBar = ({ 
  selectedCount, 
  onOpenModal, 
  searchText, 
  setSearchText, 
  headersFilters, 
  filter, 
  setFilter, 
  onSearchChange,
  membershipFilter,
  onMembershipFilterChange,
  allMemberships
}) => {
  return (
    <Box
      sx={{
        paddingRight: "2%",
        textAlign: "end",
        backgroundColor: "#D0749B",
        color: "white",
        fontWeight: 300,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 2,
        py: 2,
      }}
    >
      <Box 
        px={2} 
        display="flex" 
        gap={2} 
        alignItems="center"
        flexWrap="wrap"
        flex={1}
        minWidth="300px"
      >
        <Box flex={1} minWidth="250px">
          <Search
            searchText={searchText}
            setSearchText={setSearchText}
            color={"#767676"}
            handleSearchChange={onSearchChange}
            headersFilters={headersFilters}
            filter={filter}
            setFilter={setFilter}
          />
        </Box>
        
        <FormControl 
          size="small" 
          sx={{ 
            minWidth: 280,
            maxWidth: 350,
            backgroundColor: "white",
            borderRadius: 1,
            "& .MuiOutlinedInput-root": {
              backgroundColor: "white",
              "& fieldset": {
                borderColor: "rgba(0, 0, 0, 0.23)",
              },
              "&:hover fieldset": {
                borderColor: "#D0749B",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#D0749B",
                borderWidth: 2,
              },
            },
            "& .MuiInputLabel-root": {
              "&.Mui-focused": {
                color: "#D0749B",
              },
            },
          }}
        >
          <InputLabel 
            id="membership-filter-label"
            sx={{ 
              display: "flex", 
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <FilterListIcon fontSize="small" />
            Filtrar por Membresía
          </InputLabel>
          <Select
            labelId="membership-filter-label"
            id="membership-filter"
            value={membershipFilter}
            label="Filtrar por Membresía"
            onChange={onMembershipFilterChange}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 400,
                  "& .MuiMenuItem-root": {
                    fontSize: "0.875rem",
                    py: 1.5,
                    "&:hover": {
                      backgroundColor: "rgba(208, 116, 155, 0.08)",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "rgba(208, 116, 155, 0.12)",
                      "&:hover": {
                        backgroundColor: "rgba(208, 116, 155, 0.2)",
                      },
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="all">
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Chip 
                  label="TODAS" 
                  size="small" 
                  sx={{ 
                    fontWeight: "bold",
                    backgroundColor: "#D0749B",
                    color: "white",
                  }} 
                />
                <span>Todas las membresías</span>
              </Box>
            </MenuItem>
            {allMemberships.map((membership) => {
              const now = new Date();
              const startDate = new Date(membership.start);
              const endDate = new Date(membership.end);
              const isActive = now >= startDate && now <= endDate;
              const isPast = now > endDate;
              
              return (
                <MenuItem key={membership.id} value={membership.id}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
                    <Chip 
                      label={isActive ? "ACTIVA" : isPast ? "VENCIDA" : "FUTURA"} 
                      size="small" 
                      color={isActive ? "success" : isPast ? "error" : "info"}
                      sx={{ 
                        minWidth: 75,
                        fontWeight: "bold",
                        fontSize: "0.7rem",
                      }} 
                    />
                    <span style={{ flex: 1 }}>{formatMembershipLabel(membership)}</span>
                  </Box>
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
      
      <Box pr={2} display="flex" alignItems="center" gap={1}>
        {selectedCount > 0 && (
          <Chip 
            size="small" 
            color="secondary" 
            label={`${selectedCount} seleccionada(s)`}
            sx={{
              fontWeight: "bold",
              animation: "pulse 2s infinite",
              "@keyframes pulse": {
                "0%, 100%": { opacity: 1 },
                "50%": { opacity: 0.7 },
              },
            }}
          />
        )}
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={onOpenModal}
          sx={{
            fontWeight: "bold",
            boxShadow: 2,
            "&:hover": {
              boxShadow: 4,
              transform: "translateY(-1px)",
            },
            transition: "all 0.2s",
          }}
        >
          Dar Membresía
        </Button>
      </Box>
    </Box>
  );
};

export default TopBar;
